import { render, staticRenderFns } from "./roleAdd.vue?vue&type=template&id=5067f6f1&scoped=true&"
import script from "./roleAdd.vue?vue&type=script&lang=js&"
export * from "./roleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067f6f1",
  null
  
)

export default component.exports